export default "79cd30ae66cce40d.svg"